import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomSwitch from "../CustomSwitch/";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { grey } from "@mui/material/colors";
import "./style.css";

const MakerFilter = ({ makerChecked, setMakerChecked }) => {
  const handleChange = (event) => {
    const { name, checked } = event.target;
    setMakerChecked({ ...makerChecked, [name]: checked });
  };

  return (
    <FormGroup className='makerWap'>
      <div className='iconTitle'>
        <DirectionsCarIcon sx={{ color: grey[700] }} />
        <h3 className='makerTitle'>メーカーセレクト</h3>
      </div>
      <div className='switch'>
        <FormControlLabel
          control={
            <CustomSwitch
              checked={makerChecked.toyota}
              onChange={handleChange}
              color='warning'
              name='toyota'
              sx={{ m: 1 }}
            />
          }
          label='トヨタ'
        />
        <FormControlLabel
          control={
            <CustomSwitch
              checked={makerChecked.nonToyota}
              onChange={handleChange}
              color='warning'
              name='nonToyota'
              sx={{ m: 1 }}
            />
          }
          label='トヨタ以外'
        />
        <FormControlLabel
          control={
            <CustomSwitch
              checked={makerChecked.imported}
              onChange={handleChange}
              color='warning'
              name='imported'
              sx={{ m: 1 }}
            />
          }
          label='輸入車'
        />
      </div>
    </FormGroup>
  );
};

export default MakerFilter;
